import { Box, SxProps, Theme } from "@mui/material";

import ClinicianBadge from "./ClinicianBadge";
import { ClinicianData } from "../features/data/patientApiSlice";
import { createStyleSheet } from "../utils/styles";

const ClinicianBadgeGroup = (props: {
  clinicians: ClinicianData[];
  maxBadges: number;
  noOverlap?: boolean;
  sx?: SxProps<Theme>;
}) => {
  const { clinicians, maxBadges, noOverlap, sx } = props;
  // We'll assume the order of the clinicians is oldest->newest, and if
  // overlapping (i.e. !noOverlap) is being rendered, we'll show the newest
  // clinician on top. Since there may be an arbitrary number of badges, we'll
  // show the last 'maxBadges' clinicians in the array.
  const clinicianArray = clinicians.slice(-maxBadges);
  return clinicianArray.length > 0 ? (
    <Box
      sx={
        {
          ...styles.container,
          flexDirection: noOverlap ? "row" : "row-reverse",
          ...sx,
        } as SxProps<Theme>
      }
    >
      {clinicianArray.map((clinician, index) => (
        <ClinicianBadge
          key={clinician.name}
          clinician={clinician}
          sx={{
            ...styles.badge,
            marginLeft:
              !!noOverlap || index === clinicianArray.length - 1 ? 0 : -2,
          }}
        />
      ))}
    </Box>
  ) : null;
};

const styles = createStyleSheet({
  container: {
    display: "flex",
  },
  badge: {
    border: "1px solid white",
    width: 34,
    height: 34,
  },
});

export default ClinicianBadgeGroup;
